import axiosInstance from './axios';

/**
 * Store API key management. The backend gates these to the store owner
 * (role 2); the key secret is only ever returned by createApiKey.
 */

export const getApiKeys = async () => axiosInstance.get('/api/v1/store/api-keys/');

export const createApiKey = async ({ name, scopes }) =>
  axiosInstance.post('/api/v1/store/api-keys/', {
    name,
    ...(scopes && scopes.length ? { scopes } : {}),
  });

export const revokeApiKey = async (keyId) =>
  axiosInstance.delete(`/api/v1/store/api-keys/${keyId}/`);
